import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  colors,
  Container,
  DialogContentText,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Slide,
  Snackbar,
  Switch,
  Tooltip,
  Typography,
} from "@material-ui/core";
import API from "../../../../network/dashboardAPI";
import {
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  TablePagination,
} from "@material-ui/core";
import {
  Label,
  ListAlt,
  PermContactCalendar,
  ShoppingBasket,
  ShoppingCart,
} from "@material-ui/icons";
import EditIcon from "@material-ui/icons/Edit";
import AddIcon from "@material-ui/icons/Add";
import { useHistory } from "react-router-dom";
import _ from "lodash";
import CloseIcon from "@material-ui/icons/Close";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const AssignPicker = () => {
  /**
   */
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [supplierId, setSupplierId] = useState(null);
  const [driverId, setDriverId] = useState(null);
  const [list, setList] = useState([]);
  const [total, setTotal] = useState(0);
  const [updateId, setUpdateId] = useState(null);
  const [supplier, setSupplier] = useState([]);
  const [driver, setDriver] = useState([]);
  const [isReqSupplier, setIsReqSupplier] = useState(false);
  const [isReqDriver, setIsReqDriver] = useState(false);
  const [type, setType] = useState("");
  const [search, setSearch] = useState('');
  const [state, setState] = React.useState({
    openSnacker: false,
    vertical: 'top',
    horizontal: 'center',
  });

  const { vertical, horizontal, openSnacker } = state;

  const handleClick = (newState) => {
    setState({ openSnacker: true, ...newState });
  };

  const handleClose = () => {
    setState({ ...state, openSnacker: false });
  };

  const handleChangeDriver = (e) => {
    setDriverId(e);
  };
  const handleChangeSupplier = (e) => {
    setSupplierId(e);
  };

  // pagination
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const reset = () => {
    setDriverId(null);
    setSupplierId(null);
    setUpdateId(null);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value));
  };

  const handleClickSetup = (type, data = null) => {
    setIsReqDriver(true);
    setOpen(!open);
    switch (type) {
      case "update": {
        setType("Update");
        setDriverId(data.picker_id);
        setSupplierId(data.supplier_id);
        setUpdateId(data.id);
        break;
      }
      default: {
        setType("Create");
        break;
      }
    }
    setTimeout(() => {
      setIsReqDriver(false);
    },800)
  };
  const clodeModal = () => {
    reset();
    setOpen(false);
  };
  const getAllMappedSupplierPicker = async () => {
    setLoading(true);
    let body = {
      page: page,
      limit: rowsPerPage
    };
    if(search != ""){
      body.search = search
      body.limit = 100
    }
    await API.getAllMappedSupplierPicker(body)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.success) {
          setList(data);
          setLoading(false); 
        }
      })
      .catch((error) => {
        console.error("Error fetching supplier picker:", error); // Handle errors
      });
  };

  const getAllSupplier = async () => {
    setIsReqSupplier(true);
    let body = {
      page: page,
      limit: rowsPerPage,
    };
    await API.getAllSupplier(body)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.success) {
          setSupplier(data.data);
          setIsReqSupplier(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching supplier:", error); // Handle errors
      });
  };

  const getAllDriver = async () => {
    setIsReqDriver(true);
    let body = {
      next: page,
      limit: rowsPerPage,
    };
    await API.getAllDriverList(body)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.success) {
          setDriver(data.data);
          setIsReqDriver(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching supplier:", error); // Handle errors
      });
  };

  const createMapSupplierAndPicker = async () => {
	  if (!supplierId) {
		  alert("Supplier is required");
		  return;
	  }
	  if (!driverId) {
		  alert("Driver is required");
		  return;
	  }
    let body = {
      supplier_id: supplierId,
      picker_id: driverId,
    };
    await API.createMapSupplierAndPicker(body)
      .then((res) => res.json())
      .then((res) => {
        if (res.success) {
          setOpen(false);
          getAllMappedSupplierPicker();
        } else {
          handleClick({ vertical: 'top', horizontal: 'center' })
        }
      });
  };
  const updateMapSupplierAndPicker = async () => {
	  if (!supplierId) {
		  alert("Supplier is required");
		  return;
	  }
	  if (!driverId) {
		  alert("Driver is required");
		  return;
	  }
	  if (!updateId) {
		  alert("Update ID is required");
		  return;
	  }

    let body = {
      supplier_id: supplierId,
      picker_id: driverId,
      id: updateId,
    };
    await API.updateMapSupplierAndPicker(body)
      .then((res) => res.json())
      .then((res) => {
        if (res.success) {
          setOpen(false);
          getAllMappedSupplierPicker();
        } else {
          handleClick({ vertical: 'top', horizontal: 'center' })
          // setOpen(false);
        }
      });
  };

  const markAttendendance = async (item,status) => {
    let body = {
      picker_id: item.picker_id,
      present: status,
    };
    await API.markAttendance(body)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.success) {
          getAllMappedSupplierPicker()
        }
      })
      .catch((error) => {
        console.error("Error update:", error); // Handle errors
      });
  }

  const handleSearch = (e) => {
    setSearch(e);
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      if(search != ""){  
        getAllMappedSupplierPicker();
      }
    }, 1000);

    return () => {
      clearTimeout(handler);
    };
  }, [search]);

  useEffect(() => {
    getAllSupplier();
    getAllDriver();
  }, []);
  useEffect(() => {
    getAllMappedSupplierPicker();
  }, [page, rowsPerPage]);

  return (
    <Box component="div" m={1}>
      <Paper className="p-2">
        <Typography className="pl-4 font-bold" variant="h6">
          Supplier Picker
        </Typography>
        <Grid container spacing={1} className="my-2 pl-4">
          <Grid item sm={2}>
            <Button
              onClick={() => handleClickSetup("create")}
              variant="contained"
              color="primary"
            >
              <AddIcon /> Add Picker
            </Button>
          </Grid>
          <Grid item sm={5}>
            <TextField variant="outlined" label="search" onChange={(e) => handleSearch(e.target.value)}/> 
          </Grid>
        </Grid>
        <Container>
          <TableContainer>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>Picker Name</TableCell>
                  <TableCell>Supplier</TableCell>
                  <TableCell component="th" align="center">
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={5}>
                      <Grid
                        container
                        justifyContent="center"
                        alignItems="center"
                        style={{ minHeight: "100px" }}
                      >
                        <Grid item>
                          <CircularProgress size={40} color="primary" />
                        </Grid>
                      </Grid>
                    </TableCell>
                  </TableRow>
                ) : list.data.length ? (
                  list.data.map((item) => {
                    return (
                      <TableRow key={1} hover>
                        <TableCell>{item.id}</TableCell>
                        <TableCell>
                          {item.picker_first_name} {item.picker_last_name}
                        </TableCell>
                        <TableCell>{item.supplier_first_name}</TableCell>
                        <TableCell align="center">
                          <div className="display-flex">
                            {
                            // item.present == 1 ? 
                            // <Button variant="contained" color="primary" onClick={() => markAttendendance(item,item.present == 1 ? 0 : 1)}>Active</Button> :
                            // <Button variant="contained" color="secondary" onClick={() => markAttendendance(item,item.present == 1 ? 0 : 1)}>In Active</Button>
                            }
                            <IconButton
                              onClick={() => handleClickSetup("update", item)}
                              aria-label="edit"
                            >
                              <EditIcon style={{ color: colors.blue[600] }} />
                            </IconButton>
                          </div>
                        </TableCell>
                      </TableRow>
                    );
                  })
                ) : (
                  <TableRow>
                    <TableCell colSpan={7} align="center">
                      No Data
                    </TableCell>
                  </TableRow>
                )}
                <TableRow></TableRow>
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            component="div"
            count={list.total}
            page={page}
            rowsPerPage={rowsPerPage}
            rowsPerPageOptions={[25, 50]}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Container>
      </Paper>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={clodeModal}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">
          {type} Supplier Driver
        </DialogTitle>
        <DialogContent style={{ minWidth: "500px" }}>
          {isReqDriver || isReqSupplier ? (
            <CircularProgress size={40} color="primary" />
          ) : (
            <Grid container spacing={1}>
              <Grid className="mb-2 p-1" sm={12}>
                <FormControl fullWidth variant="outlined">
                  <InputLabel id="demo-simple-select-outlined-label1">
                    Driver
                  </InputLabel>

                  <Select
                    labelId="demo-simple-select-outlined-label1"
                    id="demo-simple-select-outlined1"
                    value={driverId}
                    defaultValue={driverId}
                    onChange={(e) => handleChangeDriver(e.target.value)}
                    label="Driver1"
                  >
                    <MenuItem value="">
                      <em>None</em>
                    </MenuItem>
                    {driver.map((data, key) => (
                      <MenuItem key={key} value={data.id}>
                        {data.first_name} {data.last_name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid sm={12} className="p-1">
                <FormControl fullWidth variant="outlined">
                  <InputLabel id="demo-simple-select-outlined-label2">
                    Supplier
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-outlined-label2"
                    id="demo-simple-select-outlined2"
                    value={supplierId}
                    defaultValue={supplierId}
                    onChange={(e) => handleChangeSupplier(e.target.value)}
                    label="Supplier2"
                  >
                    <MenuItem value="">
                      <em>None</em>
                    </MenuItem>
                    {supplier.map((data, key) => (
                      <MenuItem key={key} value={data.store_user_id}>
                        {data.first_name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={clodeModal} color="secondary">
            Close
          </Button>
          {type == "Create" ? (
            <Button
              onClick={() => {
                createMapSupplierAndPicker();
              }}
              color="primary"
            >
              {type}
            </Button>
          ) : (
            <Button
              onClick={() => {
                updateMapSupplierAndPicker();
              }}
              color="primary"
            >
              {type}
            </Button>
          )}
        </DialogActions>
      </Dialog>
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={openSnacker}
        onClose={handleClose}
        message="Already Present"
        key={vertical + horizontal}
      />
    </Box>
  );
};

export default AssignPicker;
